export type DashboardColumn = {
  type?: string
  field?: string | null
  search?: { searchable?: boolean; value?: string | null } | null
}

const ALWAYS_SEARCHABLE_TYPES = ['text', 'link']

/**
 * Row keys the dashboard search box looks into. Link and text columns are always
 * searchable: their "searchable" flag is only set by a legacy settings popover, so
 * most saved columns never had it.
 */
export function searchableKeys(columns: DashboardColumn[]): string[] {
  const keys = columns
    .filter(
      (column) =>
        column.search?.searchable === true ||
        ALWAYS_SEARCHABLE_TYPES.includes(column.type ?? '')
    )
    .map((column) => column.search?.value ?? column.field)
    .filter((key): key is string => typeof key === 'string' && key !== '')

  return [...new Set(keys)]
}

function cellText(cell: unknown): string | null {
  if (cell === null || cell === undefined) {
    return null
  }

  if (Array.isArray(cell)) {
    const texts = cell.map(cellText).filter((text) => text !== null)

    return texts.length === 0 ? null : texts.join(' ')
  }

  if (typeof cell === 'object') {
    const labelled = cell as { label?: unknown; value?: unknown }
    const text = labelled.label ?? labelled.value

    return text === null || text === undefined ? null : String(text)
  }

  return String(cell)
}

export function rowMatchesSearch(
  row: Record<string, unknown>,
  keys: string[],
  normalizedTerm: string,
  normalize: (value: string) => string
): boolean {
  return keys.some((key) => {
    const text = cellText(row[key])

    return text !== null && normalize(text).includes(normalizedTerm)
  })
}
